module.exports = {"id":"238856","name":"Pedro Sá","rating":"72","photo":"./data/images/photos/4/238856.png","club":{"name":"Portimão","logo":"./data/images/clubs/Portimao.png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PedroSa0.json
// module id = 3424
// module chunks = 0